<template>
	<form>
		<div class="repeater-form">
      <div class="panel__block">
        <h2>{{ setFormTitle }}</h2>
      </div>
		  <div class="panel__block repeater-form__row" v-for="(item, index) in getData">
		    <div v-for="(field, findex) in item" :class="setCellWidth(findex)">
          <TextInput 
            v-if="isText(field.type)"
  		    	context="repeater" 
            :type="field.type"
  		    	:value="field.value" 
  		    	:row="index"
            :k="field.field"
  		    	:index="findex"
            :label="getProtoVar(findex, 'name')"
            :id="getProtoVar(findex, 'key') + index"
            :setting="isSetting()">{{ field }}
  		    </TextInput><Dropdown
            v-if="isDropdown(field.type)"
            context="repeater"
            :proto="getProto(findex)"
            :value="field.value"
            :row="index"
            :k="field.field"
            :index="findex"
            :label="getProtoVar(findex, 'name')"
            :id="getProtoVar(findex, 'key') + index"
            :order="getProtoVar(findex, 'order')"
          ></Dropdown>
        </div>
        <div class="repeater-form__cell repeater-form__cell--remove">
          <button type="button" class="remove" @click="removeRow" :data-row="index">-</button>
        </div>
		  </div>
    </div>

	</form>
</template>

<script>

import Dropdown from './Dropdown.vue';
import TextInput from './TextInput.vue';

export default {


	components: {

    Dropdown,
		TextInput,

	}, 

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

  	addRow(e) {

  		e.preventDefault();

  		var vars  = this.$parent.getSubpanelData(),
  		    data = (vars.autofill) ? this.autofillRow(vars.autofill) : this.emptyRow(vars.proto);

  		this.$store.dispatch('addRow', {
        field: vars.field,
				data: data,
        setting: vars.setting,
  		});

  	},

    removeRow(e) {

      e.preventDefault();

      var vars = this.$parent.getSubpanelData();

      this.$store.dispatch('removeRow', {
        field: vars.field,
        index: e.srcElement.dataset.row,
        setting: vars.setting,
      })

    },

    closeModal(e) {

      e.preventDefault();

      this.$store.dispatch('closeModal');

    },

    autofillRow(f) {

      return this.$store.getters[f]();

    },

  	emptyRow(type) {

			var prototype = this.$store.getters.getPrototype('repeater', type);

			var empty = [];

			for ( var x = 0; x < prototype.length; x++ ) {

				empty[x] = {
					field: prototype[x].key,
          type:  prototype[x].type, 
					value: '',
				};

			}

			return empty;

  	},

    getProtoVar(index, prop) {

      var prototype = this.$store.getters.getPrototype('repeater', this.$parent.$data.subpanel.proto),
          val = '';

      if ( prop === 'name' ) {
        val = this._translate('repeater.' + prototype[index]['name']);
        if ( val !== '[undefined string]' ) {
          return val;
        }
      }

      if ( prototype[index][prop] !== undefined ) {

        return prototype[index][prop];

      }

      return false;


    },

    setCellWidth(findex) {

      var size = this.getProtoVar(findex, 'size'),
          c = 'repeater-form__cell cell-' + Math.round(100 / size);

      return c;

    },

    isText(type) {

      if ( type === 'text' || 
           type === 'number' ||
           type === 'percentage' ||
           type === 'textarea' ||
           type === 'currency' 
        ) {

        return true;

      }

    },

    isDropdown(type)  {

      if ( type === 'dropdown' ) {

        return true;

      }

    },

    isSetting() {

      return (this.$parent.$options.propsData.context === 'settings');

    },

    getProto(findex) {

      var prototype = this.getProtoVar(findex, 'proto');
      return prototype;

    }    

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

  	getData() {

  		var vars = this.$parent.getSubpanelData();

  		if (vars.field) {

  			var data = this.$store.getters.getRepeaterData(vars);

  			if ( data.length > 0 ) {

          var proto = this.$store.getters.getPrototype('repeater', vars.proto),

              // The parsed data object is what we will be returning. Basically, we're
              // iterating over the prototype AND the data, building the data object
              // according to the prototype. This means that if the prototype changes, 
              // we will still get any changed fields. It also means that we need to 
              // process the returned client data in such a way as to 
              parsedData = [],

              // An object into which will will add all of the data values. These will
              // be used in building out the parsedData object.
              values = {};

          // This loop will iterate over the existing data object. At this level, this
          // basically means that we are accounting for each entry in the repeater
          for ( var x = 0; x < data.length; x++ ) {

            // Add a new entry to the parsedData array;
            parsedData[x] = [];

            // Redefine the values object to null, so that we can re-populate it
            values = {};

            // Here we iterate over all the values in the data object, and save them
            // to the values object, according to their keys.
            for ( var v = 0; v < data[x].length; v++ ) {

              values[data[x][v].field] = data[x][v].value;

            }


            // Now, we iterate over every item in the PROTOTYPE. This means that we 
            // will be getting basic constructor information, which we will use to 
            // actually build out the parsedData object. Essentially, each instance 
            // in this loop is a new data point in the repeater.
            for ( var y = 0; y < proto.length; y++ ) {

              // Define a new array for this exact data point.
              parsedData[x][y] = [];

                  // value is a string containing the value
              var value = '',

                  // key is a string containing the key string
                  key = '',

                  type = '';


              // Here we iterate over each property within the prototype object. 
              // Each object represents a different property of the repeater value.
              // In this instance, we are most interested in the key and type 
              // properties
              for ( var k in proto[y] ) {

                // If the property is the key property...
                if ( k === 'key' ) {

                  // Save this to the field property of the parsedData object...
                  parsedData[x][y].field = proto[y][k];

                  // AND, set the key string
                  key = proto[y][k];

                }

                // If the property is the type property...
                if ( k === 'type' ) {

                  // Save this to the type property of the parsedData object
                  parsedData[x][y].type = proto[y][k];

                  type = proto[y][k];

                }

              }

              if ( type === 'dropdown' && value === '' ) {

                value = '';

              }


              // If our value is not undefined, save the value to the value string,
              // thereby overriding the empty value defined above.
              if ( values[key] !== undefined ) {
              
                var value = values[key];

              }

              // Finally, set the value of this particular data point.
              parsedData[x][y].value = value;              

              }

          }

          return parsedData;

  			}

  			else {

  				var empty = this.emptyRow(vars.proto);

  				this.$store.dispatch('addRow', {
  					field: vars.field,
  					data: empty,
            setting: vars.setting,
  				});

  				data = this.$store.getters.getRepeaterData(vars);

  				return data;

  			}

  		}

  		else {

  			return false;

  		}

  	},

    getPrototype() {

      var vars = this.$store.getters.modalVars;
      var proto = this.$store.getters.getPrototype('repeater', vars.proto);

      return proto;

    },

    setFormTitle() {

      var vars = this.$parent.getSubpanelData();
      return vars.title;

    }

  },

  props : [
  	
  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .repeater-form {

    padding: 2rem 0 14rem;
    margin-left: -1.5rem;

  }

  .repeater-form__row {

    position: relative;

    &:hover {

      .remove {

        opacity: 1;
        visibility: visible;

      }

    }

    .input-wrap {

      width: auto;

    }

  }

  .repeater-form__cell {

    display: inline-block;
    padding-left: 1.5rem;

    .remove {

      color: #fff;
      background-color: #999;
      -webkit-appearance: none;

      border: 0;
      line-height: 1.5;
      font-size: 10px;
      border-radius: 10px;

      position: absolute;
      top: 3.5rem;
      left: 2.5rem;

      opacity: 0;
      visibility: hidden;

      transition: background-color .1s ease, opacity .1s ease, visibility .1s ease;

      &:hover {

        background-color: #f26673;

      }

    }

  }

  .cell-100 {

    width: 100%;

  }

  .cell-50 {

    width: 50%;

  }

  .cell-33 {

    width: 33.3333%;
    
  }

  .cell-25 {

    width: 25%;

  }

</style>


// WEBPACK FOOTER //
// RepeaterForm.vue?65f47d5b